import { Navigate, Outlet } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common/enums/routing-enums";
import { useAppSelector } from "../../../store";

export function RenewalsActionReportRoute() {
  const reports = useAppSelector((state) => state.boot.configuration.actionReports?.reports);
  const isRenewalsEnabled = reports?.some((report) => report.id === "renewalsAr") ?? true;

  if (!isRenewalsEnabled) {
    return <Navigate to={ROUTE_PATHS.GROUP_MANAGEMENT_DASHBOARD} replace />;
  }

  return <Outlet />;
}
